import axiosInstance from "../../../config/axios-config";
import fileDownload from "js-file-download";

async function fetchProjectData(url, id, setData, jwtToken) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        projectId: id,
      },
    });
    const data = await response.data;
    setData(data);
  } catch (err) {
    console.error(err);
    setData(null);
  }
}

async function downloadFile(url, name, extn) {
  console.log(url);
  console.log(name + extn);
  const response = await axiosInstance.get(url, {
    responseType: "blob",
    // headers: {
    //   Authorization: `Bearer ${jwtToken}`,
    // },
  });
  const data = await response.data;
  console.log(data);

  await fileDownload(data, name + extn);
}

export { fetchProjectData, downloadFile };
